import { z } from 'zod';

const slug = z
  .string()
  .min(1, 'Slug is required')
  .max(100)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Use lowercase letters, numbers, and dashes');

const belongsToSchema = z.record(z.string(), z.union([z.string(), z.number(), z.boolean()]));

const metadata = z.object({
  belongs_to: z.array(belongsToSchema),
});

export { slug, metadata };
